'use client'
import { useSearchType } from '@/api/hooks'
import Grid from '@/components/grid/grid'
import VideoGrid from '@/components/grid/video-grid'
import { SearchTypeContext } from '@/context/search-type'
import UAParserContext from '@/context/ua-parser'
import { cn } from '@/util/cn'
import { useClientSideAPIKey } from '@/util/url'
import { GiphyFetch, MediaType } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { useContext } from 'react'
import Loader from '../components/loader'
import { useIsMobile } from '../util/use-media-query'

type Props = {
    trendingGifs?: IGif[]
    children?: React.ReactNode
    className?: string
    columnOffsets?: number[]
    hasClickableAd?: boolean
}

const fetchConfig = {
    clientMobile: 12,
    clientDesktop: 12,
} as const

const getTrackingUrl = (page: number) => `/homepage/page/${page}`

const HomeGrid = ({ trendingGifs = [], columnOffsets, className, hasClickableAd }: Props) => {
    const { deviceType } = useContext(UAParserContext)
    const apiKey = useClientSideAPIKey()
    const clientGiphyFetch = new GiphyFetch(apiKey)
    const isMobile = useIsMobile()
    const { isTransitioning } = useContext(SearchTypeContext)
    const type = useSearchType()
    const trending = (type?: MediaType) => async (offset: number) =>
        clientGiphyFetch.trending({
            offset,
            type,
            limit: deviceType === 'desktop' ? fetchConfig.clientDesktop : fetchConfig.clientMobile,
        })

    const gridFetch = trending(type == 'clips' ? 'videos' : type)
    return (
        <div className={cn('relative mt-[6px] md:mt-0', className)}>
            {isTransitioning ? (
                <Loader />
            ) : type === 'clips' ? (
                <VideoGrid fetchGifs={gridFetch} gaTrackingUrl={getTrackingUrl} />
            ) : (
                <Grid
                    key={type}
                    initialGifs={type === 'gifs' ? trendingGifs : undefined}
                    fetchGifs={gridFetch}
                    columnOffsets={type === 'gifs' && isMobile && !hasClickableAd ? undefined : columnOffsets}
                    gaTrackingUrl={getTrackingUrl}
                />
            )}
        </div>
    )
}

export default HomeGrid
